import customAxios from "./axiosConfig";

const TinkService = {
  listCredentials () {
    const api_url = window.Urls['tinkconnection_list_credentials']();
    return customAxios.get(api_url)
  },
  refreshCredentials (pk) {
    const api_url = window.Urls['tinkconnection_refresh_credentials'](pk);
    return customAxios.get(api_url)
  },
  retrieveCountry () {
    const api_url = window.Urls['tinkconnection_provider_list']()
    return customAxios.get(api_url)
  },
  status () {
    const api_url = window.Urls['tinkconnection_status']()
    return customAxios.get(api_url)
  },
  signup (params) {
    const api_url = window.Urls['tinkconnection_get_connect_link']()
    return customAxios.post(api_url, params)
  }
};

export default TinkService;